import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Diamond: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.1 3.399L1.483 8.205a1 1 0 00.038 1.251l9.932 11.618a1 1 0 001.546-.03l9.531-12.09a1 1 0 00.023-1.208L19.388 3.41a1 1 0 00-.807-.41H5.899a1 1 0 00-.799.399z"
        stroke={color}
        strokeWidth={2}
      />
      <path
        d="M5.783 3l1.913 6 3.348 10.891c.29.942 1.622.942 1.912 0L16.304 9l1.913-6"
        stroke={color}
        strokeWidth={2}
      />
      <path fill={color} d="M1 8h21.044v2H1z" />
      <path
        d="M7.696 9l3.492-4.867a1 1 0 011.625 0L16.304 9"
        stroke={color}
        strokeWidth={2}
      />
    </svg>
  );
};

export default Diamond;
